import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventEmitter } from '../../includes/eventEmitter';
import { placeTypes, placeTypeFilter, placeTypeIcon } from './place-types';
import { EnvVariables } from '../../environments/environment';
import {
  ModalController,
  LoadingController,
  AlertController,
  ActionSheetController,
  ToastController,
} from 'ionic-angular';
import * as tileQuery from '@mapbox/mapbox-sdk/services/tilequery';
import { CrudApiProvider } from '../crud-api/crud-api';
import { UserProvider } from '../user/user';
import { AuthProvider } from '../auth/auth';
import { ToolsProvider } from '../tools/tools';
import { Platform } from 'ionic-angular';
import { DrawingTools } from './drawing-tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as turf from '@turf/turf';
import { GoogleProvider } from '../google/google';
import { Plugins } from '@capacitor/core';
import * as polyline from 'geojson-polyline';
import { UserVerificationProvider } from '../user-verification/user-verification';

const { CDLLifeNavigation } = Plugins;

@Injectable()
export class TripService extends EventEmitter {
  log = debug('app:TripService');

  currentTitle = '';
  info = {
    activeTrip: null,
    isEnroute: false,
    restartingTrip: false,
    markers: [],
    markersData: [],
  };

  placeTypeIcon = placeTypeIcon;
  placeTypes = placeTypes;
  placeTypeFilter = placeTypeFilter;

  temporaryTrip: any = {};
  routeOptions = [];
  activeRouteIndex = 0;

  stopPreferences = [];

  clearenceRange = 20; //meters
  standardSearchRange = 5000; //meters
  searchArea = this.standardSearchRange; // meters
  tileQueryClient;
  stopCategories = {
    fuelStopPreference: placeTypeFilter(
      'KWIK_TRIP',
      'LOVES',
      'INDEPENDENT_TRUCK_STOP',
      'PILOT',
      'TA_PETRO'
    ),
    otherPOIs: placeTypeFilter(
      // 'TRUCK_STOP_OVERALL',
      'CAT_SCALE',
      // 'LOW_CLEARANCE',
      'REST_AREA',
      'WEIGH_STATION_OVERALL',
      // 'WALMART',
      // 'CASINO',
      'TRUCK_WASH_OVERALL'
      // 'PARKING_OVERALL',
    ),
    maintenancePreferences: placeTypeFilter(
      'APU_DEALER_SERVICE',
      'FREIGHTLINER',
      'KENWORTH',
      'INTERNATIONAL',
      'MACK',
      'PETERBILT',
      'SPEEDCO',
      'VOLVO'
    ),
    weighStations: placeTypeFilter('WEIGH_STATION_OVERALL'),
    catScales: placeTypeFilter('CAT_SCALE'),
    parking: placeTypeFilter(
      'PILOT',
      'LOVES',
      'TA_PETRO',
      'REST_AREA',
      'PARKING_OVERALL',
      'INDEPENDENT_TRUCK_STOP',
      'KWIK_TRIP',
      'SAPP_BROS'
      // 'WALMART'
    ),
    maintenance: placeTypeFilter(
      'WRECKER_SERVICES',
      'TRUCK_WASH_OVERALL',
      'FREIGHTLINER',
      'INTERNATIONAL',
      'KENWORTH',
      'APU_DEALER_SERVICE',
      'MAINTENANCE_OVERALL',
      'PETERBILT',
      'MACK',
      'VOLVO'

      // 'CAT_SCALE',
      // 'SPEEDCO',
      // 'WEIGH_STATION_OVERALL'
    ),
    addPlace: placeTypeFilter(
      'TRUCK_STOP_OVERALL',
      'REST_AREA',
      'WEIGH_STATION_OVERALL',
      'WALMART',
      'FUEL_OVERALL',
      'PARKING_OVERALL',
      'TRUCK_WASH_OVERALL',
      'LOW_CLEARANCE',
      'CASINO',
      'MAINTENANCE_OVERALL',
      'WRECKER_SERVICES',
      'LAUNDROMAT'
    ),
    all: placeTypeFilter('ALL'),
  };

  drawingTools: DrawingTools;
  placeService;

  // because of circleular dependancies, the google provider
  // passes this service in
  google: any;

  reconnectRoute = true;

  constructor(
    public http: HttpClient,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public crudApi: CrudApiProvider,
    public auth: AuthProvider,
    public user: UserProvider,
    public tools: ToolsProvider,
    public userVerification: UserVerificationProvider,
    public alertCtrl: AlertController,
    public actionSheetCtrl: ActionSheetController,
    public toastCtrl: ToastController,
    private env: EnvVariables
  ) {
    super();

    window['_tripService'] = this;
    this.drawingTools = new DrawingTools(this);
    this.tileQueryClient = tileQuery({
      accessToken: this.env.mapboxglAccessToken,
    });

    this.log('TripRouteComponentService', this);
    let currentTrip = this.user.get('currentTrip') || {};
    this.log('currentTrip: ', currentTrip);

    this.user.on('updated', () => {
      let currentTrip = this.user.get('currentTrip') || {};
      this.log('ENROUTE 2 tripService currentTrip: ', currentTrip);
      if (currentTrip.route) {
        this.log('ENROUTE 2 setting true: ', currentTrip);
        this.setEnroute(true, currentTrip);
      }
    });

    this.auth.on('logout', () => {
      this.setEnroute(false, {});
    });

    document.addEventListener('navigation-style-satellite', () => {
      this.tools.logAnalyticsEvent('trackCustom', 'inapp-navigation-satellite');
    });

    document.addEventListener('navigation-style-streets', () => {
      this.tools.logAnalyticsEvent('trackCustom', 'inapp-navigation-streets');
    });
  }

  ngOnInit() {}

  ngOnDestroy() {}

  updateTrip(trip, opts?) {
    this.set('activeTrip', trip);
    if (!_.get(opts, 'statsOnly')) {
      this.emit('updatedTripStats', trip);
    } else {
      this.emit('updatedTrip', trip);
    }

    this.log('trip for crud update', trip, this.info);
    this.info.activeTrip = trip;
    if (trip && trip.origin) {
      this.info.isEnroute = true;
    }
    this.user.saveTripToUser(trip);
    // need to setInterval for minute updates rather than every time
  }

  resetToUsersTrip() {
    this.activeRouteIndex = 0;
    this.routeOptions = [];

    const trip = this.user.get('currentTrip');

    if (trip && trip.route) {
      this.info.isEnroute = true;
      this.info.activeTrip = trip;
      this.routeOptions = [trip.route];
    } else {
      this.info.activeTrip = null;
      this.info.isEnroute = false;
    }
  }

  // Old stuff

  get(k?: any) {
    if (k === undefined) {
      return this.info;
    }
    return _.get(this.info, k);
  }

  set(k, v?: any) {
    _.set(this.info, k, v);
  }

  private setEnroute(enRoute, trip) {
    this.log(`setEnroute function: Enroute: ${enRoute}, Trip: ${trip}`);
    this.info.isEnroute = enRoute;
    this.info.activeTrip = trip;

    this.log('SET ENROUTE: ', this.info.isEnroute, this.info.activeTrip);
    this.emit('enroute', enRoute);
  }

  async openDirections(trip?) {
    if (this.tools.isWeb) {
      this.userVerification.showDownloadApp();
      return;
    }

    trip = trip || this.info.activeTrip;
    if (!trip) {
      return;
    }

    const self = this;

    this.tools.logAnalyticsEvent('trackCustom', 'inapp-navigation');

    startNav('INTERNAL');

    function startNav(type) {
      const tripWaypoints = <any>_.slice(trip.waypoints);

      handleWaypoints().then(() => {
        if (!trip.temporary) {
          self.updateTrip(trip);
        }
        openInternalNavigation(tripWaypoints, trip.destination);
      });

      function handleWaypoints(): Promise<any> {
        const wp = <any>tripWaypoints.shift();
        if (!wp) {
          return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
          if (wp.hasBeen) {
            return resolve(true);
          }

          self.log('looking at hasBeen for', wp);
          let text;
          if (_.get(wp, 'name')) {
            text = _.get(wp, 'name');
            let city = _.get(wp, 'city'),
              state = _.get(wp, 'state');

            if (city && state) {
              text += ' in ' + city + ', ' + state;
            } else if (city || state) {
              text += ' in ' + (city || state);
            }
          } else {
            text = _.get(wp, 'location.address');
          }
          const alert = self.alertCtrl.create({
            message: `Have you already been to ${text}?`,
            buttons: [
              {
                text: 'No',
                role: 'cancel',
                handler: () => {
                  resolve(false);
                },
              },
              {
                text: 'Yes',
                handler: () => {
                  resolve(true);
                },
              },
            ],
          });
          alert.present();
        }).then(hasBeen => {
          wp.hasBeen = hasBeen;
          if (!hasBeen) {
            tripWaypoints.unshift(wp);
            return Promise.resolve();
          } else {
            return handleWaypoints();
          }
        });
      }
    }

    function openInternalNavigation(tripWaypoints, destination) {
      let loader = self.loadingCtrl.create({});

      self.log('openInternalNavigation');
      self.google.geolocation.getCurrentPosition().then(
        start => {
          /*

          Example:

            Capacitor.Plugins.CDLLifeNavigation.navigate({ options:
            JSON.stringify({
              waypoints: [
                {
                  latitude: 39.0980612,
                  longitude: -94.5826587,
                  title: 'Start',
                },
                {
                  latitude: 39.0940665,
                  longitude: -94.5674123,
                  title: 'End',
                },
              ],
              mode: 'dark',
            })
          }).then(d => { console.log('d') }, e => { console.error(e) })

          */
          const waypoints = [
            {
              latitude: start.latitude,
              longitude: start.longitude,
              title: 'Start',
            },
          ];

          if (_.size(tripWaypoints)) {
            const w = _.first(tripWaypoints);
            waypoints.push(locationToWp(w, 'Destination'));
          } else {
            waypoints.push(locationToWp(trip.destination, 'Destination'));
          }

          loader.present();

          let info = {
            waypoints: waypoints,
            mode: localStorage.getItem('NAVIGATION_MODE') || 'night',
            truck: getTruck(),
          };
          self.log('navigating to', CDLLifeNavigation, info);
          self.log('%j', info);

          if (CDLLifeNavigation) {
            self.log('trying to launch navigator');
            CDLLifeNavigation.navigate({ options: JSON.stringify(info) }).then(
              () => {
                self.log('done');
              },
              e => {
                self.log('something went wrong launching navigator', e);
              }
            );
          } else {
            self.log('not navigating', info);
          }

          setTimeout(() => {
            if (trip && !self.info.activeTrip) {
              self.google.geolocation.getRecentLocationPlace().then(place => {
                trip.origin = place;

                self.info.activeTrip = trip;
                self.info.isEnroute = true;
                self.drawingTools
                  .gatherPossibleTripRoutesAndDrawRoutes({
                    trip: trip,
                  })
                  .then(() => {
                    trip.temporary = false;
                    self.log('trip now', trip);
                    self.emit('start-trip-navigation');
                  });
              });
            }

            loader.dismiss();
          }, 1500);

          function getTruck() {
            const truck = _.cloneDeep(
              _.get(trip, 'route.properties.costingOptions.truck')
            );

            // default penalty
            if (truck) {
              _.set(
                truck,
                'maneuver_penalty',
                _.get(truck, 'maneuver_penalty') || 5
              );
              _.set(truck, 'toll_cost', _.get(truck, 'toll_cost') || 15);
              _.set(truck, 'toll_penalty', _.get(truck, 'toll_penalty') || 0);
              _.set(truck, 'tolls_bias', _.get(truck, 'tolls_bias') || 0);
            }

            _.each(truck, (v, k) => {
              truck[k] = String(v);
            });

            return truck;
          }

          function locationToWp(l, title) {
            return {
              latitude: _.get(l, 'location.coordinates.1'),
              longitude: _.get(l, 'location.coordinates.0'),
              title: title,
            };
          }
        },
        e => {
          loader.dismiss();
        }
      );
    }
  }

  getDisplayedTrip() {
    return _.size(this.temporaryTrip)
      ? this.temporaryTrip
      : _.get(this, 'info.activeTrip');
  }

  getActiveRoute() {
    return this.routeOptions[this.activeRouteIndex];
  }

  // by default, loads along active route. You can pass geometry if you want to
  getListOfPossibleStopsAlongRoute(
    geometry?,
    mode = 'all',
    opts?,
    route?
  ): Promise<any> {
    opts = opts || {};
    this.emit('placesMode', mode);

    let queries = null;

    this.searchArea = this.standardSearchRange;
    queries = _.filter(placeTypes, <any>{ isActive: true }).map(d => {
      if (_.get(d, 'query')) {
        return _.get(d, 'query');
      } else if (_.get(d, 'id')) {
        return { placeId: _.get(d, 'id') };
      } else {
        return { placeType: _.get(d, 'placeType') };
      }
    });
    this.tools.emit('queryPlaceTypeCount', _.size(queries));

    if (!_.size(queries)) {
      this.hidePlaceLayer();
      return new Promise((resolve, reject) => {
        return setTimeout(() => {
          resolve([]);
        });
      });
    }

    let activeRoute = null;
    if (_.isUndefined(route)) {
      activeRoute = this.getActiveRoute() || {};
    } else {
      activeRoute = route;
    }

    this.log('will get places');
    if (!_.size(activeRoute)) {
      this.log('will get map vectors');
      return this.addPlaceLayer().then(async () => {
        const ids = _.map(queries, 'placeId').filter(d => d);
        await this.filterPlaceLayerIds(ids);
      });
    } else {
      this.log('will get manual markers');
      return this.getListOfPossibleStopsAlongRouteWithMarkers(
        queries,
        activeRoute
      );
    }
  }

  getListOfPossibleStopsAlongRouteWithMarkers(
    queries,
    route,
    limit = 300
  ): Promise<any> {
    this.hidePlaceLayer();

    let encoded;
    encoded = polyline.encode(route);
    encoded.properties = {};

    return this.crudApi
      .post('/api/places/read', {
        limit: limit,
        $or: queries,
        location: {
          route: encoded,
          searchArea: this.searchArea,
        },
      })
      .then(
        async res => {
          const markers = _.map(res.data, p => {
            p.icon = 'icon icon-Map_Pin_' + placeTypeIcon(p, 'iconPin');
            return {
              type: 'Feature',
              properties: p,
              geometry: p.location,
            };
          });
          this.log('got markers', markers);

          // this.mapComponent.updateMarkers(markers, false, places);
          try {
            const m = await this.getMap();
            m.activeComponent.updateMarkers(markers, false, null, {});
          } catch (e) {}
        },
        e => {}
      )
      .catch(e => {
        return Promise.resolve([]);
      });
  }

  completeTrip(trip?) {
    localStorage.removeItem('sponsorship-maps-interstitial-skip');
    trip = trip || _.get(this, 'info.activeTrip');
    this.log('going to complete this trip and save', trip);
    if (!trip) {
      return Promise.resolve();
    }
    let loader = this.loadingCtrl.create({
      content: 'Saving Trip...',
    });
    loader.present();
    if (!trip) {
      return;
    }
    let t = _.merge(trip, {
      dates: {
        completed: moment(),
      },
    });

    t.actualRoute = _.map(t.actualRoute, loc => {
      return [_.round(loc[0], 4), _.round(loc[1], 4)];
    });

    return this.crudApi
      .post('/api/trips', t)
      .then(res => {
        return this.user.saveTripToUser({}).then(
          () => {
            this.setEnroute(false, null);
            this.info.activeTrip = {};
            _.set(this.user, 'info.activeTrip', {});
            this.tools.logEventAndFlush('tripCompleted');
            loader.dismiss();
            this.temporaryTrip = null;
            this.routeOptions = [];
            return Promise.resolve(res.data);
          },
          e => {
            loader.dismiss();
            this.setEnroute(false, null);
            this.info.activeTrip = {};
            _.set(this.user, 'info.activeTrip', {});
            this.tools.logEventAndFlush('tripCompleted');
            this.temporaryTrip = null;
            this.routeOptions = [];
          }
        );
      })
      .catch(e => {
        this.log('there was an error', e);
        const toast = this.toastCtrl.create({
          message: 'There was an error saving your trip',
          duration: 3000,
        });
        toast.present();
        loader.dismiss();
      });
  }

  cancelRoute(trip?) {
    this.log('going to cancel this trip and save');
    trip = trip || this.info.activeTrip;
    this.temporaryTrip = {};
    delete this.info.activeTrip;
    this.routeOptions = [];
    if (!trip) {
      return;
    }

    this.user.saveTripToUser({}).then(
      () => {
        // double check we aren't enroute ...
        // it's possible we reloaded the user's info while this request
        // was happening.
        //
        // But we also do immediately (see below) to prevent delay
        this.setEnroute(false, null);
      },
      e => {}
    );
    this.setEnroute(false, null);
    this.emit('routeCancelled');
    this.user.updateUser();
  }

  addPlaceStop(place) {
    this.log('add place: ', place);
    const trip = this.getDisplayedTrip();
    this.log('trip waypoints: ', trip.waypoints);
    if (!trip) return;
    if (this.isPlaceInWaypoints(place)) {
      this.log('already in waypoints');
      return;
    }
    trip.waypoints = trip.waypoints || [];

    const p = _.clone(place);

    delete p.googlePlaceData;

    // verify all existing waypoints have a distance
    _.forEach(trip.waypoints, waypoint => {
      const distance = _.get(waypoint, 'distance');
      if (!distance) {
        this.log('we have no distance', trip);
        waypoint.distance = getDistanceFromPoint(waypoint, trip.route);
      }
    });

    //
    let placeDistance = _.get(place, 'distance');

    if (!placeDistance) {
      placeDistance = place.distance = getDistanceFromPoint(place, trip.route);
    }

    this.log('distance along', placeDistance);

    if (_.isNumber(placeDistance)) {
      let inserted = false;
      let index = 0;
      _.forEach(trip.waypoints, point => {
        this.log('looping waypoints', point);
        if (!inserted) {
          this.log(
            'not inserted yet',
            _.toNumber(_.get(point, 'distance')),
            placeDistance
          );
          if (_.toNumber(_.get(point, 'distance')) >= placeDistance) {
            trip.waypoints.splice(index, 0, place);
            inserted = true;
          }
        }
        index += 1;
      });
      if (!inserted) {
        trip.waypoints.push(p);
      }
    }

    this.drawingTools.gatherPossibleTripRoutesAndDrawRoutes({
      recenter: false,
    });

    if (trip === this.info.activeTrip) {
      this.updateTrip(trip);
    }

    // local fns
    function getDistanceFromPoint(place, route) {
      const pointOnLine = turf.nearestPointOnLine(
        route,
        {
          type: 'Feature',
          properties: {},
          geometry: place.location,
        },
        { units: 'miles' }
      );
      return _.get(pointOnLine, 'properties.location', 100000);
    }
  }

  removePlaceStop(place) {
    const trip = this.getDisplayedTrip();
    if (!trip) return;
    trip.waypoints = trip.waypoints || [];
    if (this.isPlaceInWaypoints(place)) {
      _.forEach(trip.waypoints, waypoint => {
        if (_.get(waypoint, '_id') === _.get(place, '_id')) {
          _.pull(trip.waypoints, waypoint);
        }
      });
      this.drawingTools.gatherPossibleTripRoutesAndDrawRoutes({
        recenter: false,
      });
    }
    this.updateTrip(trip);
  }

  isPlaceInWaypoints(place): Boolean {
    const trip = this.getDisplayedTrip();
    if (!trip) return false;

    let b = false;

    this.log('isPlaceInWaypoints waypoint checking', place, trip);
    _.forEach(_.get(trip, 'waypoints'), waypoint => {
      if (_.get(waypoint, '_id') === _.get(place, '_id')) {
        b = true;
      } else {
      }

      if (
        _.get(place.placeType, 'GOOGLE_PLACE') &&
        _.get(waypoint, '_id') ===
          _.get(place.locationMetadata, 'googlePlaceId')
      ) {
        b = true;
      }
    });

    return b;
  }

  // Drawing Tools
  getMap(): Promise<any> {
    return Promise.resolve(this.drawingTools.getMap());
  }
  getMapCurrentZoom() {
    return Promise.resolve(this.drawingTools.getCurrentZoom());
  }

  gatherPossibleTripRoutesAndDrawRoutes(opt?) {
    return Promise.resolve(
      this.drawingTools.gatherPossibleTripRoutesAndDrawRoutes(opt)
    );
  }

  setActiveRoute(ri?) {
    this.drawingTools.setActiveRoute(ri);
  }

  // We don't ever send a full route to the server because it's too large
  // ... but we may need it for inapp navigation, so we are storing in local
  // storage

  setFullRoute(route) {
    const id = new Date().getTime();
    _.set(route, 'properties.timestamp', id);
    const r = _.cloneDeep(route);
    _.set(r, 'properties.FULL_ROUTE', true);
    localStorage.setItem('FULL_ROUTE', JSON.stringify(r));
  }

  getFullRoute() {
    try {
      const route = JSON.parse(localStorage.getItem('FULL_ROUTE')),
        id = _.get(this.info, 'activeTrip.route.properties.timestamp');

      route.properties.FULL_ROUTE = true;

      if (id === _.get(route, 'properties.timestamp')) {
        return route;
      } else {
        return _.get(this.info, 'activeTrip.route');
      }
    } catch (e) {
      return _.get(this.info, 'activeTrip.route');
    }
  }

  navigateToPlace(place) {
    if (this.tools.isWeb) {
      this.userVerification.showDownloadApp();
      return;
    }

    const tempTrip = {
      temporary: true,
      origin: {}, // not used
      waypoints: [],
      destination: place,
    };

    this.log('navigateToPlace', place);

    const chooseVechileModal = this.modalCtrl.create('ChooseVehiclePage', {
      allowNone: true,
    });

    chooseVechileModal.onDidDismiss(truck => {
      let p = Promise.resolve();

      this.log('navigateToPlace truck', truck);
      if (truck) {
        this.google.getCostingOptions(truck).then(options => {
          _.set(tempTrip, 'route.properties.costingOptions', options);
        });
      }

      p.then(() => {
        this.log('navigateToPlace trip', tempTrip);
        this.openDirections(tempTrip);
      });
    });
    chooseVechileModal.present();
  }

  async addPlaceLayer() {
    const map = await this.getMap();

    if (map.getLayer('ALL_PLACES')) {
      return;
    }

    try {
      const iconImage = ['match', ['get', 'placeId']];

      _.each(placeTypes, pt => {
        if (pt.id) {
          iconImage.push([pt.id], 'Map_Pin_' + (pt.iconPin || pt.icon));
        }
      });

      iconImage.push('Map_Pin_Independant_Truck_Stop');

      /*
      map.addLayer({
        id: 'ALL_PLACES_TEXT',
        type: 'symbol',
        source: {
          type: 'vector',
          url: 'mapbox://cdllife.3mokzrco',
        },
        'source-layer': 'all-places-1y6zeo',
        minzoom: 9,
        layout: {
          visibility: 'none',
          'text-field': ['to-string', ['get', 'name']],
          'text-size': 13,
          'text-font': ['Roboto Regular', 'Arial Unicode MS Regular'],
          'text-offset': [0, 1.5],
          // 'text-allow-overlap': true,
        },
        paint: {
          'text-color': '#222222',
        },
      });
      */

      map.addLayer({
        id: 'ALL_PLACES',
        type: 'symbol',
        source: 'allCDLLifePlaces',
        'source-layer': 'places',
        minzoom: 3,
        maxzoom: 22,

        layout: {
          visibility: 'none',
          'icon-allow-overlap': true,
          'icon-anchor': 'bottom',
          'icon-image': iconImage,
          'icon-size': 0.5,
        },
        paint: {
          'text-color': '#222222',
        },
      });
    } catch (e) {
      // console.warn('ERROR', e);
      return; // already added
    }

    map.on(
      'click',
      'ALL_PLACES',
      _.debounce(async e => {
        try {
          const features = map.queryRenderedFeatures(e.point, {
              layers: ['ALL_PLACES'],
            }),
            marker: any = _.first(features),
            ac = map.activeComponent;

          if (ac && marker) {
            const place = await this.queryMarkerById(marker);
            this.placeService.places = [place.properties];
            ac.activeMarker.emit(place);
            this.activateMarker(place.properties._id);
          } else {
            this.activateMarker(null);
          }
        } catch (e) {}
      }, 100)
    );
  }

  async queryMarkerById(
    marker,
    opts: any = {
      dontWait: true,
    }
  ): Promise<any> {
    const id = _.get(marker, 'properties._id');

    const promise = this.crudApi.get('/api/places/' + id).then(d => {
      d = <any>d;
      if (d && d.data) {
        return Promise.resolve({
          type: 'Feature',
          properties: d.data,
          geometry: d.data.location,
        });
      } else {
        return Promise.reject('bad data');
      }
    });

    if (opts.dontWait) {
      const datum: any = {
        type: 'Feature',
        properties: _.get(marker, 'properties'),
        geometry: _.get(marker, 'geometry'),
      };

      Object.defineProperty(datum.properties, '__loadingPromise', {
        value: promise,
        writable: true,
        enumerable: false,
      });

      promise.then(data => {
        _.merge(datum, data);
        delete datum.properties.__loadingPromise;
      });

      return datum;
    } else {
      return promise;
    }
  }

  private async filterPlaceLayerIds(ids) {
    try {
      const map = await this.getMap();

      ids = _.map(ids, d => d).filter(d => d);
      if (_.size(ids)) {
        await this.showPlaceLayer();
        ids.unshift('placeId');
        ids.unshift('in');
        map.setFilter('ALL_PLACES', ids);
      } else {
        await this.hidePlaceLayer();
        this.placeService.places = [];
      }
    } catch (e) {}
  }

  private async hidePlaceLayer() {
    try {
      const map = await this.getMap();

      await this.addPlaceLayer();
      map.setLayoutProperty('ALL_PLACES', 'visibility', 'none');
      // map.setLayoutProperty('ALL_PLACES_TEXT', 'visibility', 'none');
      this.placeService.places = [];
      this.placeService.showingLayer = false;
    } catch (e) {}
  }

  private async showPlaceLayer() {
    try {
      const map = await this.getMap();

      await this.addPlaceLayer();
      map.setLayoutProperty('ALL_PLACES', 'visibility', 'visible');
      // map.setLayoutProperty('ALL_PLACES_TEXT', 'visibility', 'visible');
      this.placeService.showingLayer = true;
    } catch (e) {}
  }

  async activateMarker(id?) {
    try {
      const map = await this.getMap();

      if (id) {
        map.setLayoutProperty('ALL_PLACES', 'icon-size', [
          'match',
          ['get', '_id'],
          [id],
          0.75,
          0.5,
        ]);
      } else {
        map.setLayoutProperty('ALL_PLACES', 'icon-size', 0.5);
      }
    } catch (e) {
      console.warn('error', e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/trip-service/trip-service.ts